import React from "react";
import { Page } from "@/components/Page";
import { SEO } from "@/components/SEO";
import { Button } from "@/components/Button";
import { ASSETS } from "@/data/site";
import { Home as HomeIcon } from "lucide-react";

const NotFound = () => (
  <Page>
    <SEO title="Page Not Found" />
    <section className="min-h-[80vh] flex items-center justify-center navy-gradient grain relative overflow-hidden">
      <div className="ssa-container relative text-center">
        <img src={ASSETS.emblem} alt="" className="h-20 w-20 object-contain mx-auto opacity-90" />
        <div className="mt-8 font-display text-7xl text-white">404</div>
        <p className="mt-4 text-white/70 max-w-md mx-auto">
          The page you are looking for has drifted off course. Let us guide you back to safe harbour.
        </p>
        <div className="mt-8 flex justify-center">
          <Button to="/" variant="light" size="lg">
            <HomeIcon className="h-4 w-4" /> Return Home
          </Button>
        </div>
      </div>
    </section>
  </Page>
);

export default NotFound;
